module.exports = __webpack_public_path__ + "static/media/authBg.341345e3.jpg";